import { createComponent } from '@front/utils/alpine';
const Address = createComponent((opts) => ({
    isOpen: false,
    choiceName: 'Pays*',
    choice: opts.choice ?? '',
    form: opts.form ?? '',
    open() {
        this.isOpen = true;
    },
    close() {
        this.isOpen = false;
    },
    toggle() {
        this.isOpen = !this.isOpen;
    },
    scrollTo(key) {
        if (!this.isOpen) {
            return;
        }
        const firstElement = this.getCountriesByKeyPress(key);
        firstElement?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest',
        });
    },
    getCountriesByKeyPress(key) {
        const list = document.querySelectorAll('.js-country-list-' + this.form + ' li');
        return Array.from(list).find((el) => el.textContent?.trim().startsWith(key.toUpperCase()));
    },
}));
export { Address };
